import React from 'react';
import './LoadingSpinner.scss';

type Props = {
  inline?: boolean;
};

const LoadingSpinner: React.FC<Props> = ({ inline }) => {
  return (
    <div
      className={`spinner-container ${inline ? 'spinner-container__inline' : ''}`}
    >
      <div className="spinner"></div>
    </div>
  );
};

export default LoadingSpinner;
